export function getPlayerPrefix(username) {
    if (username === undefined || username.length === 0) {
        return '-_';
    }
    if (username.length === 1) {
        return username[0].toUpperCase() + username[0].toLowerCase();
    }
    return username[0].toUpperCase() + username[1].toLowerCase();
}
//# sourceMappingURL=PlayerUtils.js.map